<div class="row">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-4">Primary DI</th>
                    <th class="col-sm-8">Issuing Agency</th>
                  </tr>
                  <tr>
                    <td><label controlName="udiDI"></label></td>
                    <td><label controlName="agency"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table formArrayName="deviceDescriptionForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th colspan="2">Device Description</th>
                  </tr>
                  <ng-container *ngIf="deviceDescriptionForm?.controls?.length; else emptyTemplate2fields">
                  <tr formGroupName="{{i}}" *ngFor="let name of deviceDescriptionForm.controls; let i = index">
                    <td class="breakAll" colspan="2"> <label
                        controlName="value"></label></td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-2">Quantity of Device</th>
                    <th class="col-sm-4">Version or Model</th>
                    <th class="col-sm-6">Software as a Medical Device (SaMD) Version</th>
                  </tr>
                  <tr>
                    <td><label controlName="quantityOfDevice"></label></td>
                    <td class="breakAll"><label
                        controlName="versionOrModel"></label></td>
                    <td class="breakAll"><label
                        controlName="softwareAsAMedicalDevice"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>

          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped table-striped">
                <tbody>
                  <tr>
                    <th class="col-sm-6">Production Identification Controlled By:</th>
                    <th class="col-sm-6"></th>
                  </tr>
                  <tr>
                    <td>Expiration Date?</td>
                    <td><label
                        controlName="isExpirationDate"></label></td>
                  </tr>
                  <tr>
                    <td>Manufacturing Date?</td>
                    <td><label
                        controlName="isManufacturingDate"></label></td>
                  </tr>
                  <tr>
                    <td>Lot or Batch Number?</td>
                    <td><label
                        controlName="isLotOrBatchNumber"></label></td>
                  </tr>
                  <tr>
                    <td>Serial Number?</td>
                    <td><label
                        controlName="isSerialNumber"></label></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate2fields>
  <tr>
    <td role="gridcell" colspan="2"><label></label></td>
  </tr>
</ng-template>
